import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

// PROD-741 — Cashback / Fee-Waiver promotions.
// Backend routes: app/api/v1/routes/b2b/loans/promotions.py
//   GET  /b2b/loans/promotions/catalog                  -> { cashBack[], feeWaiver[] } (active today)
//   GET  /b2b/loans/applications/{id}/promotions        -> { cashBack[], feeWaiver[], totalAmount, synced }
//   PUT  /b2b/loans/applications/{id}/promotions        -> replace the applied set
export const promotionsAPI = createApi({
  reducerPath: 'promotionsAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PromotionCatalog', 'AppliedPromotions'],
  endpoints: (builder) => ({
    // LOS-configured promotions active today (both types).
    getPromotionCatalog: builder.query({
      query: () => ({
        url: `/b2b/loans/promotions/catalog`,
        method: 'GET',
        headers: getHeaders(),
      }),
      providesTags: ['PromotionCatalog'],
    }),

    // Promotions applied to a deal + display-only total.
    getAppliedPromotions: builder.query({
      query: ({ applicationId }) => ({
        url: `/b2b/loans/applications/${applicationId}/promotions`,
        method: 'GET',
        headers: getHeaders(),
      }),
      providesTags: (_result, _err, { applicationId }) => [
        { type: 'AppliedPromotions', id: applicationId },
      ],
    }),

    // Replace the applied set (send the complete desired ids to add/remove).
    applyPromotions: builder.mutation({
      query: ({ applicationId, cashBackPromotionIds, feeWaiverPromotionIds }) => ({
        url: `/b2b/loans/applications/${applicationId}/promotions`,
        method: 'PUT',
        body: {
          cashBackPromotionIds: cashBackPromotionIds || [],
          feeWaiverPromotionIds: feeWaiverPromotionIds || [],
        },
        headers: getHeaders(),
      }),
      invalidatesTags: (_result, _err, { applicationId }) => [
        { type: 'AppliedPromotions', id: applicationId },
      ],
    }),
  }),
});

export const {
  useGetPromotionCatalogQuery,
  useGetAppliedPromotionsQuery,
  useApplyPromotionsMutation,
} = promotionsAPI;
